import React, { useState, useRef, useEffect } from "react";
import {
  MwInputFile,
  MwSelectorProduct,
  MwButton,
  MwSpinner,
  MwSelector,
} from "../../ui";
import {
  FaTimes,
  FaPlus,
  FaRegSave,
  FaExchangeAlt,
  FaArrowDown,
  FaArrowUp,
} from "react-icons/fa";
import {
  useCurrent,
  useDelete,
  useFetch,
  usePost,
  useUploadFile,
} from "../../../hooks";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import CardHeadeWithActions from "../../ui/CardHeadeWithActions";
import useDeleteWBody from "./../../../hooks/useDeleteWBody";
import OsMwSelectorAccount from "./OsMwSelectorAccount";
import { useTranslation } from "react-i18next";

const InventoryForm = ({ permissionType }) => {
  const [t, i18n] = useTranslation("global");

  const { tenant } = useParams();
  const navigate = useNavigate();
  const [fileKey, setFileKey] = useState(null);
  const [fileLocation, setFileLocation] = useState(null);
  const [file, setFile] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null); // New state for file preview
  const [rows, setRows] = useState([
    {
      item: "",
      unitPrice: "",
      quantity: "",
      balanceBefore: 0,
      balanceAfter: 0,
      total: 0,
      product_id: "",
      product_uom_id: "",
      product_uom_name: "",
      product_uom_template_id: "",
    },
  ]);
  const [newRow, setNewRow] = useState({
    id: null,
    item: "",
    price: "",
    product_id: 0,
  });
  const [subAccount, setSubAccount] = useState("");
  const [warehouses, setWarehouses] = useState([]);
  const [reqNo, setReqNo] = useState("");
  const [reqNote, setReqNote] = useState("");
  const [reqAttach, setReqAttach] = useState(null);
  const [reqDate, setReqDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [fromWarehouse, setFromWarehouse] = useState(null);
  const [toWarehouse, setToWarehouse] = useState(null);
  const [errors, setErrors] = useState({
    reqDate: "",
    fromWarehouse: "",
    toWarehouse: "",
    reqNo: "",
    subAccount: "",
    rows: [],
  });
  const isRTL = i18n.dir() === "rtl";

  const { currentTenantId, currentCompanyId, currentBranchId, userName } =
    useCurrent();
  const { postData, loading, error, data } = usePost();

  const warehousesUrl = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
  const RequisitionsNumber = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/requisitions/gen-code/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
  const {
    data: warehousesData,
    loading: warehousesLoading,
    error: warehousesError,
  } = useFetch(warehousesUrl);
  const {
    data: NumberData,
    loading: NumberLoading,
    error: NumberError,
  } = useFetch(RequisitionsNumber);
  console.log("number :", NumberData);
  const {
    deleteItem,
    loading: deleteLoading,
    error: deleteError,
  } = useDeleteWBody();
  const {
    location,
    loading: uploadLoading,
    error: uploadError,
    handleUpload,
  } = useUploadFile(
    [
      "image/png",
      "image/jpeg",
      "image/gif",
      "image/webp",
      "application/pdf",
      "image/svg+xml",
      "image/bmp",
      "image/tiff",
    ],
    "requisitions",
  );

  useEffect(() => {
    if (location) {
      // Extract the key from the location URL
      // const key = location.split('/').slice(-1)[0];
      setFileKey(location);
      setFileLocation(location);
      setSelectedFile({
        name: reqAttach?.name || "Uploaded file",
        type: reqAttach?.type || "application/octet-stream",
        url: location,
      });
    }
  }, [location]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setReqAttach(file);
      handleUpload(e);
    }
  };

  const handleRemoveFile = async () => {
    if (fileKey) {
      try {
        await deleteItem(process.env.REACT_APP_UPLOADS_API_BASE_URL, {
          keyFile: fileKey,
        });
        URL.revokeObjectURL(selectedFile?.url);
        setSelectedFile(null);
        setReqAttach(null);
        setFileKey(null);
        setFileLocation(null);

        // Reset the file input
        const fileInput = document.getElementById("file_upload");
        if (fileInput) {
          fileInput.value = "";
        }
      } catch (error) {
        toast.error("حدث خطأ أثناء حذف الملف", {
          position: "top-center",
          autoClose: 3000,
          rtl: true,
          theme: "colored",
        });
      }
    }
  };
  useEffect(() => {
    if (warehousesData && warehousesData.data) {
      setWarehouses(warehousesData.data);
    }
  }, [warehousesData]);

  // Watch for API response
  useEffect(() => {
    if (data) {
      if (data.status === 1) {
        toast.success(t("deleted.data_added_successfully"), {
          position: "top-center",
          autoClose: 3000,
          rtl: true,
          theme: "colored",
        });
        // Reset form or redirect here if needed
        setTimeout(() => {
          navigate(`/${tenant}/requisition`);
        }, 2000);
      } else {
        toast.error(data.message || t("deleted.error_fetching_data"), {
          position: "top-center",
          autoClose: 3000,
          rtl: true,
          theme: "colored",
        });
      }
    }
  }, [data]);

  useEffect(() => {
    if (NumberData?.data) {
      setReqNo(NumberData.data);
    }
  }, [NumberData]);

  // Add this to handle error response from the submit
  useEffect(() => {
    if (error) {
      // Check if the error message includes 'duplicate' to show specific message
      if (error.message?.includes("exists")) {
        toast.error(t("requisition.duplicate_number"), {
          position: "top-center",
          autoClose: 3000,
          rtl: isRTL,
          theme: "colored",
        });
      } else {
        // Show general error message
        toast.error(error.message || t("deleted.error_fetching_data"), {
          position: "top-center",
          autoClose: 3000,
          rtl: isRTL,
          theme: "colored",
        });
      }
    }
  }, [error, isRTL, t]);

  const validateFields = () => {
    let tempErrors = {
      reqDate: "",
      fromWarehouse: "",
      toWarehouse: "",
      reqNo: "",
      subAccount: "",
      rows: [],
    };
    let isValid = true;

    // Validate main form fields
    if (!reqDate) {
      tempErrors.reqDate = "التاريخ مطلوب";
      isValid = false;
    }

    if (!fromWarehouse) {
      tempErrors.fromWarehouse = "المخزن مطلوب";
      isValid = false;
    }

    if (permissionType === "TRANS" && !toWarehouse) {
      tempErrors.toWarehouse = "المخزن المستهدف مطلوب";
      isValid = false;
    }

    if (!reqNo) {
      tempErrors.reqNo = "الرقم مطلوب";
      isValid = false;
    }

    // Validate each row's required fields
    const rowErrors = rows.map((row) => ({
      // item: !row.item ? 'البند مطلوب' : '',
      item: !row.item && !row.product_id ? "البند مطلوب" : "",
      quantity: !row.quantity ? "الكمية مطلوبة" : "",
    }));

    if (rowErrors.some((error) => error.item || error.quantity)) {
      tempErrors.rows = rowErrors;
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (!validateFields()) {
      toast.error(t("deleted.fill_required_fields"), {
        position: "top-center",
        autoClose: 3000,
        rtl: true,
        theme: "colored",
      });
      return;
    }

    const items = rows.map((row) => ({
      requisition_master_id: 1,
      product_id: row.product_id,
      product_name: row.item,
      product_uom_id: row.product_uom_id,
      product_uom_name: row.product_uom_name,
      product_uom_template_id: row.product_uom_template_id,
      qty: row.quantity,
      balance_before: row.balanceBefore,
      balance_after: row.balanceAfter,
      total: row.total,
    }));

    const requestData = {
      warehouse_id: Number(fromWarehouse),
      warehouse_id_to: permissionType === "TRANS" ? Number(toWarehouse) : null,
      req_type: permissionType,
      req_no: reqNo || null,
      req_note: reqNote,
      req_attach: fileKey,
      req_status: 1,
      req_date: reqDate,
      account_no: subAccount,
      tenant_id: currentTenantId,
      company_id: currentCompanyId,
      branch_id: currentBranchId,
      created_by: userName,
      items: items,
    };
    console.log("Post-requestData", requestData);
    await postData(
      `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/requisitions/master`,
      requestData,
    );
  };

  const addRow = () => {
    setRows([
      ...rows,
      {
        item: "",
        unitPrice: "",
        quantity: "",
        balanceBefore: 0,
        balanceAfter: 0,
        total: 0,
        product_id: "",
        product_uom_id: "",
        product_uom_name: "",
        product_uom_template_id: "",
      },
    ]);
  };

  const removeRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
  };

  const handleInputChange = (index, field, value) => {
    const newRows = [...rows];
    newRows[index][field] = value;

    if (field === "quantity") {
      const quantity = parseFloat(value) || 0;
      const balanceBefore = parseFloat(newRows[index].balanceBefore) || 0;
      newRows[index].balanceAfter = balanceBefore + quantity;
    }

    if (field === "quantity" || field === "unitPrice") {
      const quantity = parseFloat(newRows[index].quantity) || 0;
      const unitPrice = parseFloat(newRows[index].unitPrice) || 0;
      newRows[index].total = quantity * unitPrice;
    }

    setRows(newRows);
  };

  const handleProductSelect = (selectedProduct, index) => {
    // التحقق من وجود المنتج المحدد و الـ id الخاص به
    if (selectedProduct && selectedProduct._id) {
      // الحصول على اسم المنتج باللغة الإنجليزية، إذا لم يجد يرجع string فارغة
      // const productName = selectedProduct?.productName.find((name) => name.lang === 'en')?.text || '';
      const productName =
        selectedProduct?.productName.find((name) => name.lang === "en")?.text ||
        selectedProduct?.productName.find((name) => name.lang === "ar")?.text;
      //  || 'منتج بدون اسم';
      // الحصول على id المنتج من أول أو ثاني عنصر في مصفوفة الأسماء، إذا لم يجد يرجع string فارغة
      const productId =
        selectedProduct?.productName[0]?._id ||
        selectedProduct.productName[1]?._id ||
        "";

      // باقي البيانات اختيارية وليست مهمة للتحقق من صحة المنتج
      const productUomId = selectedProduct?.uomPurchase?.id || "";
      const productUomName = selectedProduct?.uomPurchase?.short_name || "";
      const productUomTemplateId = selectedProduct?.uomTemplate?.id || "";
      const balanceBefore = selectedProduct?.qty || 0;
      const cost = selectedProduct?.cost || 0;

      const newRows = [...rows];
      newRows[index] = {
        ...newRows[index],
        // القيم الأساسية المطلوبة هي الاسم و الـ id فقط
        item: productName,
        product_id: productId,
        // باقي القيم اختيارية
        product_uom_id: productUomId,
        product_uom_name: productUomName,
        product_uom_template_id: productUomTemplateId,
        balanceBefore: balanceBefore,
        balanceAfter: balanceBefore + (newRows[index].quantity || 0),
        unitPrice: cost,
        total: cost * (newRows[index].quantity || 0),
      };
      setRows(newRows);
    }
  };
  const handleAddProduct = (newProduct) => {
    console.log("New Product Added:", newProduct);
  };

  const formatNumber = (number) => {
    return Number(number).toFixed(2);
  };

  const labelStyles = `block text-sm mb-1 text-[#251658] font-medium ${isRTL ? "text-right" : "text-left"}`;
  const requiredStar = "*";
  const inputStyles = `w-full p-2 border border-gray-200 rounded-md text-[#251658] font-medium focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-sm ${isRTL ? "text-right" : "text-left"}`;
  // const smallInputStyles = `w-full p-1.5 border border-gray-200 rounded-md text-[#251658] text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 ${isRTL ? 'text-right' : 'text-left'}`;
  const handleCancel = () => {
    navigate(`/${tenant}/requisition`);
  };
  // Modified styles for centered inputs
  //  const centeredInputStyles = `${smallInputStyles} text-center`;

  return (
    <div
      className={`bg-white  h-[calc(100vh-100px)] overflow-y-scroll custom-scrollbar  rounded-lg   ${isRTL ? "rtl" : "ltr"}`}
      dir={isRTL ? "rtl" : "ltr"}
    >
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={isRTL}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ top: "60px" }}
      />

      <CardHeadeWithActions
        title={
          <>
            {permissionType === "TRANS" && (
              <FaExchangeAlt className="inline-block mx-2" />
            )}
            {permissionType === "PUSH" && (
              <FaArrowDown className="inline-block mx-2" />
            )}
            {permissionType === "PULL" && (
              <FaArrowUp className="inline-block mx-2" />
            )}
            {permissionType === "TRANS"
              ? t("requisition.type_transfer")
              : permissionType === "PUSH"
                ? t("requisition.type_receive")
                : permissionType === "PULL"
                  ? t("requisition.type_issue")
                  : permissionType}
          </>
        }
      >
        <MwButton
          actionType="button"
          inGroup={true} // علشان نخلي الزر جزء من مجموعة
          type="saveBtn" // نوع الزر
          onClick={handleCancel}
          disabled={loading}
          classNameCustom={loading ? "opacity-50 cursor-not-allowed" : ""}
        >
          {t("requisition.requisition_list")}
        </MwButton>

        {/* زر الإضافة */}
      </CardHeadeWithActions>
      <div className="bg-white w-[98%] mx-auto rounded-lg shadow-sm  ">
        <div className="flex justify-end mt-2">
          <MwButton
            actionType="button"
            size="sm"
            inGroup={true} // علشان نخلي الزر جزء من مجموعة
            type="saveBtn" // نوع الزر
            onClick={handleSubmit}
            disabled={loading}
            classNameCustom={loading ? "opacity-50 cursor-not-allowed" : ""}
          >
            {loading ? (
              <span>جارٍ الحفظ...</span>
            ) : (
              <>
                <FaRegSave /> {/* أيقونة الإضافة */}
                {t("requisition.save")}
              </>
            )}
          </MwButton>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 mt-1 gap-3 items-start">
          {/* عمود معلومات الطلب */}
          <div className="bg-gray-50 p-5 rounded-lg">
            <h5
              className={`${
                isRTL ? "text-right" : "text-left"
              } text-[#251658] mb-4 font-bold text-sm`}
            >
              {t("requisition.requisition_information")}
            </h5>
            {/* تقسيم الحقلين على صف واحد بنفس المساحة والفجوة */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className={labelStyles}>{t("requisition.type")}</label>
                <input
                  type="text"
                  value={
                    permissionType === "TRANS"
                      ? t("requisition._transfer")
                      : permissionType === "PUSH"
                        ? t("requisition._receive")
                        : permissionType === "PULL"
                          ? t("requisition._issue")
                          : permissionType
                  }
                  className={`${inputStyles} bg-white w-full`}
                  readOnly
                />
              </div>
              <div>
                <label className={labelStyles}>
                  {t("requisition.date")} {requiredStar}
                </label>
                <input
                  type="date"
                  value={reqDate}
                  onChange={(e) => setReqDate(e.target.value)}
                  className={`${inputStyles} ${
                    errors.reqDate ? "border-red-500" : ""
                  } bg-white w-full`}
                />
              </div>
            </div>
          </div>

          {/* عمود معلومات المخزن */}
          <div className="bg-gray-50 p-6 rounded-lg">
            <h5
              className={`${
                isRTL ? "text-right" : "text-left"
              } text-[#251658] mb-4 font-bold text-sm`}
            >
              {t("requisition.Store_Information")}
            </h5>
            {/* استخدم شبكة بحيث إذا كان نوع الإذن TRANS يتم عرض عمودين، وإذا مش TRANS يعرض عمود واحد */}
            <div
              className={`${permissionType === "TRANS" ? "grid grid-cols-2 gap-3" : "grid grid-cols-1 gap-3"}`}
            >
              <div>
                <label className={labelStyles}>
                  {t("requisition.warehouseName")} {requiredStar}
                </label>
                <MwSelector
                  withSearch={false}
                  _data={warehouses.map((warehouse) => ({
                    _id: warehouse.id,
                    label: warehouse.name_ar || warehouse.name,
                    value: warehouse.id,
                  }))}
                  dataType="labelValue"
                  setSelectedItem={(item) => setFromWarehouse(item.value)}
                  selectedItem={
                    fromWarehouse
                      ? {
                          _id: fromWarehouse,
                          label: warehouses.find(
                            (w) => w.id === parseInt(fromWarehouse),
                          )?.name_ar,
                          value: fromWarehouse,
                        }
                      : null
                  }
                  initalValue={t("requisition.choose_warehouse")}
                  withLabel={false}
                  invalid={!!errors.fromWarehouse}
                  invalidMsg={errors.fromWarehouse}
                />
              </div>

              {permissionType === "TRANS" && (
                <div>
                  <label className={labelStyles}>
                    {t("requisition.to")} {requiredStar}
                  </label>
                  <MwSelector
                    withSearch={false}
                    _data={warehouses
                      .filter(
                        (warehouse) => warehouse.id !== parseInt(fromWarehouse),
                      )
                      .map((warehouse) => ({
                        _id: warehouse.id,
                        label: warehouse.name_ar || warehouse.name,
                        value: warehouse.id,
                      }))}
                    dataType="labelValue"
                    setSelectedItem={(item) => setToWarehouse(item.value)}
                    selectedItem={
                      toWarehouse
                        ? {
                            _id: toWarehouse,
                            label: warehouses.find(
                              (w) => w.id === parseInt(toWarehouse),
                            )?.name_ar,
                            value: toWarehouse,
                          }
                        : null
                    }
                    initalValue={t("requisition.choose_warehouse")}
                    withLabel={false}
                    invalid={!!errors.toWarehouse}
                    invalidMsg={errors.toWarehouse}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* بيانات الأصناف */}
        <div className="bg-gray-50 p-6 mt-3 rounded-lg">
          <h5
            className={`${isRTL ? "text-right" : "text-left"} text-[#251658] mb-4 font-bold text-sm`}
          >
            {t("requisition.item_details")}
          </h5>

          {/* Header Row */}
          <div
            className="mb-2 text-xs text-[#251658]"
            style={{
              display: "grid",
              gridTemplateColumns: "0.5fr 6.5fr 1fr 1fr 1fr 1fr 2fr",
              gap: "0.5rem",
            }}
          >
            {/* عمود الرقم */}
            <div className="text-center text-xs">#</div>
            {/* عمود البند */}
            <div className={`${isRTL ? "text-right" : "text-left"}`}>
              {t("requisition.item")} {requiredStar}
            </div>
            <div className="text-center">{t("requisition.purchase_price")}</div>
            <div className="text-center">
              {t("requisition.quantity")} {requiredStar}
            </div>
            <div className="text-center">{t("requisition.balance_before")}</div>
            <div className="text-center">{t("requisition.balance_after")}</div>
            <div className="text-center">{t("requisition.total")}</div>
          </div>

          {/* Rows */}
          {rows.map((row, index) => (
            <div
              key={index}
              className={`text-[#251658] items-center relative mb-4 ${
                index === rows.length - 1 ? "" : "border-b border-gray-300 pb-2"
              }`}
              style={{
                display: "grid",
                gridTemplateColumns: "0.5fr 6.5fr 1fr 1fr 1fr 1fr 2fr",
                gap: "0.5rem",
              }}
            >
              {/* عمود الرقم */}
              <div className="text-center text-xs">{index + 1}</div>

              {/* عمود البند */}
              <div>
                <div
                  className={
                    errors.rows[index]?.item
                      ? "border border-red-500 rounded-md"
                      : ""
                  }
                >
                  <MwSelectorProduct
                    onChangeCallback={(selectedProduct) =>
                      handleProductSelect(selectedProduct, index)
                    }
                    withLabel={false}
                    value={row.item}
                    initalValue={row.item}
                    placeholder={t('product.searchProduct')}
                    onCreateProduct={handleAddProduct}
                    disabled={false}
                    inputStyle={{
                      color: "black",
                      textAlign: isRTL ? "right" : "left",
                      padding: "0.5rem 1rem",
                    }}
                  />
                </div>
              </div>

              {/* عمود السعر */}
              <div>
                <input
                  type="number"
                  value={row.unitPrice || ""}
                  onChange={(e) =>
                    handleInputChange(index, "unitPrice", e.target.value)
                  }
                  placeholder={t('requisition.purchase_price')}
                  className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md text-center focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                />
              </div>

              {/* عمود الكمية */}
              <div>
                <input
                  type="number"
                  value={row.quantity}
                  onChange={(e) =>
                    handleInputChange(index, "quantity", e.target.value)
                  }
                  placeholder={t('requisition.quantity')}
                  className={`w-full px-3 py-2 text-xs border rounded-md text-center focus:ring-2 focus:ring-blue-500 bg-white ${
                    errors.rows[index]?.quantity
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                />
              </div>

              {/* عمود الرصيد قبل */}
              <div>
                <input
                  type="text"
                  value={formatNumber(row.balanceBefore)}
                  readOnly
                  className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md text-center bg-gray-50"
                />
              </div>

              {/* عمود الرصيد بعد */}
              <div>
                <input
                  type="text"
                  value={formatNumber(row.balanceAfter)}
                  readOnly
                  className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md text-center bg-gray-50"
                />
              </div>

              {/* عمود الإجمالي وزر الحذف */}
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  value={formatNumber(row.total)}
                  readOnly
                  className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md text-center bg-gray-50 font-medium"
                />
                <button
                  onClick={() => removeRow(index)}
                  className="text-red-500 hover:text-red-700 p-2 rounded-full hover:bg-red-100 transition-colors"
                >
                  <FaTimes className="text-sm" />
                </button>
              </div>
            </div>
          ))}

          {/* Footer Section */}
          <div className="mt-8 space-y-6">
            {/* Add Row Button */}
            <div className="flex justify-start">
              <MwButton
                actionType="button"
                inGroup={true}
                type="saveBtn"
                onClick={addRow}
                size="sm"
              >
                <FaPlus className="text-sm" />
                {t("requisition.add_row")}
              </MwButton>
            </div>

            {/* Total Summary Section */}
            <div className="border-t border-gray-200 pt-3">
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-8" />
                <div className="col-span-4">
                  <div className="space-y-3">
                    <h3 className="text-[#251658] font-semibold text-right text-sm">
                      {t("requisition.total_summary")}:
                    </h3>
                    <input
                      type="text"
                      value={formatNumber(
                        rows.reduce((sum, row) => sum + row.total, 0),
                      )}
                      readOnly
                      className="w-full px-2 py-1 text-sm border-2 border-gray-300 rounded-lg bg-gray-50 font-bold text-gray-800 text-center shadow-sm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 p-6 mt-3 rounded-lg  ">
          <div className="pt-4">
            <h5
              className={`${isRTL ? "text-right" : "text-left"} text-[#251658] mb-4 font-bold text-sm`}
            >
              {t("requisition.account_info")}{" "}
            </h5>
            <div className="space-y-4">
              <div
                className={`grid ${permissionType === "TRANS" ? "grid-cols-1" : "grid-cols-2"} gap-4`}
              >
                {permissionType !== "TRANS" && (
                  <div>
                    <label className={labelStyles}>
                      {" "}
                      {t("requisition.sub_account")}{" "}
                    </label>
                    <OsMwSelectorAccount
                      onChangeCallback={(selectedAccount) => {
                        // Handle selected account, e.g.:
                        setSubAccount(selectedAccount.account_no);
                        // Or any other logic you need
                      }}
                      withLabel={false}
                      initalValue=""
                    />
                  </div>
                )}
                <div>
                  <label className={labelStyles}>
                    {t("requisition.number")}
                  </label>
                  {NumberLoading ? (
                    <div className="flex justify-center items-center h-[100px]">
                      <MwSpinner size="md" />
                    </div>
                  ) : (
                    <input
                      style={{ textAlign: "center" }}
                      type="text"
                      className={`${inputStyles} ${errors.reqNo ? "border-red-500" : ""} bg-white`}
                      value={reqNo}
                      placeholder={t('requisition.number')}
                      onChange={(e) => setReqNo(e.target.value)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* معلومات اخرى */}
        <div className="bg-gray-50 p-6 mt-3 rounded-lg  ">
          <div className="pt-4">
            <h5
              className={`${isRTL ? "text-right" : "text-left"} text-[#251658] mb-4 font-bold text-sm`}
            >
              {t("requisition.other_info")}
            </h5>
            <div className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className={labelStyles}>
                    {t("requisition.notes")}
                  </label>
                  <textarea
                    className={`${inputStyles} min-h-[85px]   bg-white`}
                    value={reqNote}
                    placeholder={t('requisition.enter_notes')}
                    onChange={(e) => setReqNote(e.target.value)}
                  />
                </div>
                <div>
                  <label className={labelStyles}>
                    {t("requisition.attachments")}
                  </label>
                  <div className="border-2  bg-white border-dashed  rounded-lg p-4">
                    <MwInputFile
                      onChangeHandler={handleFileChange}
                      acceptTypes="image/*,.webp,.svg,.bmp,.tiff,application/pdf,.pdf"
                      label="اضغط على الملف هنا او اختر من جهازك"
                      id="file_upload"
                      isMultiple={false}
                      isSmall={false}
                      disabled={uploadLoading}
                    />
                    {selectedFile && (
                      <div className="mt-4">
                        <div className="flex items-center justify-between mb-2">
                          <p className="text-sm text-[#251658]">
                            {" "}
                            {t("requisition.selected_file")} :{" "}
                            {selectedFile.name}
                          </p>
                          <button
                            onClick={handleRemoveFile}
                            className="p-1 hover:bg-red-50 rounded-full text-red-500 hover:text-red-700 transition-colors"
                            title="إلغاء الملف"
                            disabled={deleteLoading}
                          >
                            <FaTimes size={16} />
                          </button>
                        </div>
                        {selectedFile.type.startsWith("image/") ||
                        selectedFile.name.toLowerCase().endsWith(".webp") ? (
                          <img
                            src={selectedFile.url}
                            alt="Preview"
                            className="max-w-xs mx-auto"
                          />
                        ) : (
                          selectedFile.type === "application/pdf" && (
                            <div className="flex items-center justify-center">
                              <embed
                                src={selectedFile.url}
                                type="application/pdf"
                                width="100%"
                                height="300px"
                              />
                            </div>
                          )
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventoryForm;
